import { Country } from '@src/global/types/types';

const isCountryInRegion = (country: Country, region: string) => {
  return country.region === region;
};

const isCountryNotRestricted = (
  country: Country,
  restrictedCountries: string[]
) => {
  return !restrictedCountries.includes(country.isoCodeTwo);
};

export const getAvailableCountries = (
  countries: Country[],
  region: string,
  restrictedCountries?: string[]
): Country[] => {
  return countries.filter((country) => {
    const isInRegion = !region || isCountryInRegion(country, region);
    const isNotRestricted =
      !restrictedCountries?.length ||
      isCountryNotRestricted(country, restrictedCountries);

    return isInRegion && isNotRestricted;
  });
};
